<template>
  <div class="form-group mb-20">
    <label v-if="label" :for="id" class="form-label">{{ label }}</label>
    <input
      class="form-control"
      :id="id"
      :type="type"
      v-model="internalValue"
      :placeholder="placeholder"
      :aria-describedby="ariaDescribedBy"
      v-bind="$attrs"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <small v-if="error" :id="`error-${id}`" class="form-text text-error">{{
      error
    }}</small>
    <small v-else-if="hint" :id="`hint-${id}`" class="form-text text-muted">{{
      hint
    }}</small>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "AppInput",
  props: {
    modelValue: [String, Number],
    placeholder: String,
    label: String,
    hint: String,
    error: String,
    type: {
      type: String,
      default: "text",
    },
    id: {
      type: String,
      default: () => `input-${Math.random().toString(36).substr(2, 9)}`,
    },
  },
  emits: ["update:modelValue", "input", "blur", "focus"],
  setup(props, { emit }) {
    const internalValue = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const ariaDescribedBy = computed(() => {
      if (props.error) return `error-${props.id}`;
      if (props.hint) return `hint-${props.id}`;
      return null;
    });

    return {
      internalValue,
      ariaDescribedBy,
    };
  },
});
</script>

<style scoped lang="less">
@import "@/styles/_input-styles.less";
</style>
